<template>
  <div class="content py-5">
    <v-card>
      <v-card-title>
        Aprovação de usuários
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Procurar"
                  single-line
                  hide-details
                />
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-card-text>
        <v-data-table
          :items="usuarios"
          :search="search"
          :headers="headers"
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
          no-data-text="Sem usuários para aprovar"
          class="elevation-1"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.cpf }}</td>
              <td>{{ item.user_address.complement }}</td>
              <td>{{ item.type_client }}</td>
              <td class="text-xs-right">
                <ActionButton
                  message="Rejeitar solicitação"
                  icon="clear"
                  color="error"
                  @onclick="reasonNoAccept(item.id)"
                />
                <ActionButton
                  message="Aceitar solicitação"
                  icon="done"
                  color="success"
                  @onclick="acceptUser(item.id)"
                />
                <ActionButton
                  message="Visualizar comprovante"
                  icon="assignment"
                  color="info"
                  @onclick="checkReceipt(item)"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="receiptModal"
      max-width="450"
      transition="dialog-transition"
    >
      <v-card width="550px">
        <v-btn icon class="ma-0" @click="receiptModal = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-card-text>
          <img
            v-if="proof_of_address != '' && proof_of_address != null"
            style="width:100%; height:auto;"
            :src="`${url_bucket + proof_of_address}`"
          />
          <div v-else>
            Comprovante não enviado!
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog width="400" v-model="reason">
      <v-card class="pa-4">
        <div class="pb-3 text-center">
          <span class="title font-weight-medium"
            >Selecione o motivo da exclusão do usuário:</span
          >
        </div>
        <v-radio-group hide-details v-model="reasonRadio" class="pb-4">
          <v-radio
            label="Usuário não é morador ou locatário do condomínio"
            value="naomorador"
            color="primary"
          ></v-radio>
          <v-radio
            label="Faltaram dados para a identificação do usuário"
            value="dados"
            color="primary"
          ></v-radio>
        </v-radio-group>
        <v-textarea
          outline
          single-line
          label="Outro"
          v-model="reasonText"
          color="primary"
        >
        </v-textarea>
        <v-layout d-flex>
          <v-btn
            class="white--text grey darken-1 ma-0"
            @click="(reason = false), (reasonText = null)"
            >Cancelar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="white--text error ma-0"
            :disabled="!reasonText && !reasonRadio"
            @click="noAcceptUser(userId)"
            >Excluir usuário</v-btn
          >
        </v-layout>
      </v-card>
    </v-dialog>

    <BlockUI
      v-if="blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />
  </div>
</template>

<script>
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import Constants from '../../models/constants/Constants';
import UserController from '../../controllers/UserController';
import ActionButton from '../shared/ActionButtonsTemplate';

export default {
  components: { ActionButton },

  data() {
    return {
      userController: new UserController(this.$resource),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      search: '',
      headers: [
        { text: 'Nome', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Telefone', value: 'phone' },
        { text: 'CPF', value: 'cpf' },
        { text: 'Complemento', value: 'user_address.complement' },
        { text: 'Tipo', value: 'type_client' },
        { text: 'Complemento', value: 'user_address.complement' },
        { text: 'Ações', value: 'actions', sortable: false },
      ],
      url_bucket: Constants.URL_BUCKET_PICKNDRIVE,
      proof_of_address: '',
      receiptModal: false,
      usuarios: [],
      reason: false,
      userId: null,
      reasonText: null,
      reasonRadio: null,
    };
  },

  created() {
    this.getUsers();
  },

  methods: {
    reasonNoAccept(userId) {
      this.userId = userId;
      this.reason = true;
    },

    checkReceipt(user) {
      this.receiptModal = true;
      this.proof_of_address = user.proof_of_address;
    },

    noAcceptUser(userId) {
      this.reason = false;
      this.userController
        .forceDelete(userId)
        .then(res => {
          this.getUsers();
          this.$awn.success(res.message);
        })
        .catch(e => {
          this.$awn.alert(e.message);
        });
      this.reasonText = null;
      this.userId = null;
    },

    acceptUser(user_id) {
      swal({
        title: 'Deseja realmente aprovar este usuário?',
        icon: 'success',
        buttons: true,
        dangerMode: true,
      }).then(willApproval => {
        if (willApproval) {
          this.userController
            .userApproval(user_id)
            .then(res => {
              this.getUsers();
              this.$awn.success('Usuário aprovado com sucesso.');
            })
            .catch(e => {
              this.$awn.alert('Erro ao aprovar usuário.');
            });
          }
        });
    },

    async getUsers() {
      try {
        this.blockScreen = true;
        const u = await this.userController.getByClientIdForApproval();

        for (let i = 0; i < u.length; i++) {
          const id = u[i]
          if (id.approved == false) {
            this.usuarios.push(id)
          }
        }

      } catch (error) {
        return this.$awn.alert('Erro ao obter usuários');
      } finally {
        this.blockScreen = false;
      }
    },
  },
};
</script>
